import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Suggest from './Suggest'
import { connect } from 'react-redux'
import { fetchSuggestions } from '../ESSearch/actions'
import { createEvent } from '../UserEvents/actions'
import { TrackingHOC, OptionsHOC } from '../../hocs'
import { selectSuggestions } from './selectors'
import styled, { css } from 'styled-components'

const Form = styled.form`
  height: var(--search-input-height);
  position: ${props => (props.isInModal ? 'initial' : 'relative')};
  margin: 60px auto 30px;

  input {
    -webkit-appearance: none; /* stop ios style input field */
  }

  .react-autosuggest__container {
    z-index: 0;
  }
  .react-autosuggest__suggestions-container {
    top: ${props => (props.isInModal ? '138px' : 'var(--search-input-height)')};
    border: ${props => (props.isInModal ? 'none' : '1px solid var(--grey-7)')};
    width: ${props => (props.isInModal ? '100%' : 'var(--search-input-width)')};
  }
  .react-autosuggest__section-title {
    padding-top: ${props => (props.isInModal ? '50px' : '0px')};
  }
  .react-autosuggest__suggestions-container li {
    font-size: ${props => (props.isInModal ? '1.1rem' : '0.8rem')};
    ${props => !props.isInModal && '--search-spacing: 5px;'};
    border-bottom: ${props =>
      props.isInModal ? 'none' : '1px solid var(--grey-7)'};
  }

  @media (max-width: 768px) {
    margin: 0;
  }
  ${props =>
    props.isInModal &&
    css`
      width: var(--modal-width);
      
      @media only screen and (max-width: 768px) {
        margin: 0px auto;
        border: 2px solid var(--clr-accent);
        border-radius: 5px;

        button {
          margin-right: var(--5xl);
          background: none;
          border-radius: 0px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        input {
          width: 100%;
          border-radius: 0px;
          outline: none;
        }

        button,
        button:focus,
        input,
        input:focus {
          border: none;
        }

        button svg {
          fill: var(--clr-accent);
        }

        .react-autosuggest__suggestions-container {
          top: unset;
          border: none;
        }

        .react-autosuggest__section-title {
          padding-top: 10px;
        }
      }
    `}
`

const SearchInput = ({
  handleChange,
  query,
  toggleSearchModal,
  createEvent,
  fetchSuggestions,
  getOption,
  suggestions,
  isInModal
}) => {
  const [inputValue, setInputValue] = useState(query)
  const [showSuggestions, setShowSuggestions] = useState(false)

  const onInputChange = (e, { newValue, method }) => {
    setInputValue(newValue)
    setShowSuggestions(true)
    if (newValue && method === 'type') {
      fetchSuggestions(newValue)
    }
  }

  const handleSubmit = e => {
    e.preventDefault()
    const query = inputValue.trim()

    if (query !== '') {
      setShowSuggestions(false)
      handleChange(query)
      trackSearch(query, 'submit')
      toggleSearchModal(query)
    }
  }

  const handleSelect = (e, { suggestion }) => {
    handleChange(suggestion)
    trackSearch(suggestion, 'select_suggestion')
    toggleSearchModal(suggestion)
  }

  const handleClear = () => {
    handleChange('')
  }

  const trackSearch = (query, action) => {
    createEvent({
      category: 'search',
      data: {
        action: action,
        search_term: query
      }
    })
  }

  const suggestionProps = {
    suggestions,
    onChange: onInputChange,
    value: inputValue,
    handleSelect: handleSelect,
    handleSubmit: handleSubmit,
    handleClear: handleClear,
    searchPlaceholder: getOption('searchPlaceholder'),
    isInModal,
    showSuggestions
  }

  return (
    <Form onSubmit={handleSubmit} isInModal={isInModal}>
      <Suggest {...suggestionProps} />
    </Form>
  )
}

SearchInput.propTypes = {
  toggleSearchModal: PropTypes.func,
  handleChange: PropTypes.func,
  query: PropTypes.string,
  getOption: PropTypes.func.isRequired,
  fetchSuggestions: PropTypes.func.isRequired,
  createEvent: PropTypes.func.isRequired,
  suggestions: PropTypes.arrayOf(PropTypes.string).isRequired,
  isInModal: PropTypes.bool.isRequired
}

SearchInput.defaultProps = {
  toggleSearchModal: () => {},
  handleChange: () => {},
  query: '',
  isInModal: false
}

const mapStateToProps = state => ({
  suggestions: selectSuggestions(state)
})

const mapDispatchToProps = dispatch => ({
  createEvent: event => dispatch(createEvent(event)),
  fetchSuggestions: query => dispatch(fetchSuggestions.request(query))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrackingHOC(OptionsHOC(SearchInput)))



// WEBPACK FOOTER //
// ./src/containers/ESSearch/SearchInput.js